export const HEADERS = ['Сумма кредита', 'Ставка', 'Срок'];
